import { get, internalDestroy, internalPost, internalPut } from '.';

import qs from 'qs';

export const getSegments = ({ filters }) => {
  return get(`/segments?${qs.stringify(filters)}`);
};

export const getSegment = ({ segmentId, locale }) => {
  return get(`/segments/${segmentId}?${qs.stringify(locale)}`);
};

export const createSegment = ({ payload, locale }) => {
  return internalPost(`/segments?${qs.stringify(locale)}`, payload);
};

export const updateSegment = ({ segmentId, payload, locale }) => {
  return internalPut(`/segments/${segmentId}?locale=${locale}`, payload);
};

export const deleteSegment = ({ segmentId, payload }) => {
  return internalDestroy(`/segments/${segmentId}`, payload);
};
